import React, { createContext, useState, useContext } from 'react';

// Import images from src/assets
import beachImg from './assets/beach.jpg';
import forestImg from './assets/forest.jpg';
import desertImg from './assets/desert.jpg';
import snowImg from './assets/snow.jpg';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [currentTheme, setCurrentTheme] = useState('beach');

  const toggleDarkMode = () => setIsDarkMode(prev => !prev);
  const changeTheme = (theme) => setCurrentTheme(theme);

  const themes = {
    beach: {
      name: 'Beach',
      type: 'beach',
      bgImage: beachImg, // Use imported image
      bgColor: '#e6f7ff',
      buttonColor: '#03a9f4',
      cardBg: '#E0FFFF',
      textColor: '#006994',
      accentColor: '#20B2AA'
    },
    mountain: {
      name: 'Forest',
      type: 'forest',
      bgImage: forestImg, // Use imported image
      bgColor: '#e8f5e9',
      buttonColor: '#4caf50',
      cardBg: '#F0FFF0',
      textColor: '#228B22',
      accentColor: '#6B8E23'
    },
    desert: {
      name: 'Desert',
      type: 'desert',
      bgImage: desertImg, // Use imported image
      bgColor: '#ffecd1',
      buttonColor: '#ff9800',
      cardBg: '#FFF8DC',
      textColor: '#8B4513',
      accentColor: '#DAA520'
    },
    snow: {
      name: 'Snow',
      type: 'snow',
      bgImage: snowImg, // Use imported image
      bgColor: '#e0f3ff',
      buttonColor: '#4a90e2',
      cardBg: '#ffffff',
      textColor: '#333333',
      accentColor: '#87CEEB'
    },
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleDarkMode, currentTheme, changeTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;